import React, { useState } from "react";
import { Layout, Card, Form, Input, Button, Spin, Switch } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { postAPI, displayMessage } from "../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../constants/messages";
import { APP_PAGE_CREATE } from "../../constants/api";

function AppPageAdd() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const createData = (values) => {
    setLoading(true);
    postAPI(
      APP_PAGE_CREATE,
      values,
      (res) => {
        if (res.status) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          navigate("/app-pages");
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to create page");
      }
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Add Application Page"
          extra={
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={createData}>
              <Form.Item
                name="title"
                label="Page Title"
                rules={[{ required: true }]}
              >
                <Input placeholder="Ex: Kitchen Stock Report" />
              </Form.Item>

              <Form.Item
                name="route"
                label="Route Path"
                rules={[{ required: true }]}
              >
                <Input placeholder="/kitchen/report/stock" />
              </Form.Item>

              <Form.Item
                name="is_enabled"
                label="Enable Page"
                valuePropName="checked"
                initialValue={true}
              >
                <Switch />
              </Form.Item>

              <Form.Item name="remark" label="Remark">
                <Input.TextArea rows={3} />
              </Form.Item>

              <Form.Item style={{ textAlign: "right" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default AppPageAdd;
